import { FC } from 'react'

import styled from 'styled-components'

import PlayIcon from 'src/Assets/Svg/player/play.svg?react'
import TrackCoverDefault from 'src/Assets/Svg/common/track-cover.svg'
import { transformPlaylistApiUrlToBrowserUrl } from 'src/Pages/Curator/PlaylistsPage/components/PlayList/halpers'

import { SmartImage } from '../../SmartImage'

interface PlaylistCoverProps {
  coverUrl?: string
  playlistUrl?: string
}

const CoverLink = styled.a`
  display: block;
  text-decoration: none;
  flex-shrink: 0;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`

const POSITION_DIVIDER = 3

const IconWrapper = styled.div<{
  $size: number
}>`
  position: absolute;

  top: ${({ $size }) => $size / POSITION_DIVIDER}px;
  left: ${({ $size }) => $size / POSITION_DIVIDER}px;
`

const TrackImageWrapper = styled.div`
  cursor: pointer;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
`

export const TrackCoverImage = styled(SmartImage)`
  display: flex;
  align-items: center;
`

export const PlaylistCover: FC<PlaylistCoverProps> = ({
  coverUrl,
  playlistUrl,
}: PlaylistCoverProps) => {
  const transformedUrl = playlistUrl
    ? transformPlaylistApiUrlToBrowserUrl(playlistUrl)
    : ''

  return (
    <CoverLink href={transformedUrl} target='_blank' rel='noopener noreferrer'>
      <TrackImageWrapper>
        <IconWrapper $size={48}>
          <PlayIcon width={16} height={16} />
        </IconWrapper>

        <TrackCoverImage
          src={coverUrl}
          fallbackSrc={TrackCoverDefault}
          width={48}
          height={48}
        />
      </TrackImageWrapper>
    </CoverLink>
  )
}
